<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competencia"
                    label="Competência"
                    show-default-option
                    text-field="valor"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                competencia: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('raas.procedimento'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.procedimento.create({ origem: 'geracao' })
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.model.origem = 'geracao'
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.procedimento.store(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
}
</script>